var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2",attrs:{"text":"","icon":"","color":"primary","x-small":""},nativeOn:{"click":function($event){return _vm.pressed.apply(null, arguments)}}},[_c('v-icon',[_vm._v("far fa-trash-alt")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }